document.addEventListener('DOMContentLoaded', function () {
  var slides = document.querySelectorAll('.mv-slide__slide');
  var backgroundColors = Array.from(slides).map(slide => slide.dataset.backgroundColor);

  document.body.style.background = backgroundColors[0];

  const splideMV = '#splide-mv';
  const splideMvOptions = {
    mediaQuery: 'min',
    type   : 'loop',
    autoplay: true,
    interval: 5000,
    speed: 1000,
    perPage: 1,
    rewind: true,
    pagination: true,
    arrows: true,
    focus  : 'center',
    updateOnMove: true,
    isNavigation: true,
    breakpoints: {
      641: {
        fixedWidth: '530px',
      }
    },
  }

  if (document.querySelectorAll(splideMV).length > 0) {
    const mySplide = new Splide(splideMV, splideMvOptions);
    mySplide.mount();

  // mySplide.on('moved', function (newIndex) {
  //   document.body.style.backgroundColor = backgroundColors[newIndex % backgroundColors.length];
  // });

  mySplide.on('move', function (newIndex) {
    if (window.scrollY < document.documentElement.scrollHeight / 2) {
      document.body.style.backgroundColor = backgroundColors[newIndex % backgroundColors.length];
    }
  });

  window.addEventListener('scroll', function () {
    if (window.scrollY >= document.documentElement.scrollHeight / 2) {
      document.body.style.backgroundColor = 'white';
    } else {
      document.body.style.backgroundColor = backgroundColors[mySplide.index % backgroundColors.length];
    }
  });
  }
});

const splideProductThumbnails_main = '#splide-product-thumbnails';
const splideProductThumbnails_options = {
  mediaQuery: 'max',
  type   : 'slide',
  autoplay: false,
  perPage: 1,
  perMove: 1,
  gap: "10px",
  rewind: false,
  focus  : 'center',
  trimSpace: 'move',
  pagination: false,
  arrows: true,
  updateOnMove: true,
  isNavigation: true,
  grid: {
		rows: 2,
		cols: 5,
		gap : {
			row: '20px',
			col: '20px',
		},
  },
  breakpoints: {
    640: {
      destroy: true,
    }
  },
}

// if (document.querySelectorAll(splideProductThumbnails_main).length > 0) {
//   const splideProductThumbnails = new Splide(splideProductThumbnails_main, splideProductThumbnails_options);
//   splideProductThumbnails.mount();
// }

const el = document.querySelector(splideProductThumbnails_main);

if (el) {
  const splide = new Splide(el, splideProductThumbnails_options);

  // Grid拡張を有効化
  splide.mount(window.splide.Extensions);
}

// function reorderThumbsColumnMajor(listEl, rows, colsMax) {
//   const slides = Array.from(listEl.children);
//   const pageSize = rows * colsMax; // 2x4=8 を1ページ単位として扱う
//   const out = [];

//   for (let base = 0; base < slides.length; base += pageSize) {
//     const chunk = slides.slice(base, base + pageSize);

//     // ★最後ページなど「枚数が足りない」時は列数を実際に埋まる分に縮める
//     const colsEff = Math.min(colsMax, Math.ceil(chunk.length / rows));

//     // 列優先：r0 -> r1 の順で、各行に c0,c1,c2... を割り当てる
//     for (let r = 0; r < rows; r++) {
//       for (let c = 0; c < colsEff; c++) {
//         const idx = c * rows + r;
//         if (chunk[idx]) out.push(chunk[idx]);
//       }
//     }
//   }

//   listEl.append(...out);
// }

// const sel = '#splide-product-thumbnails';
// const el = document.querySelector(sel);

// if (el) {
//   const list = el.querySelector('.splide__list');

//   // ★1回だけ並び替え（再初期化やリサイズで二重適用しない）
//   if (list && !list.dataset.colMajorDone) {
//     reorderThumbsColumnMajor(list, 2, 4); // rows=2, colsMax=4（=2行4列）
//     list.dataset.colMajorDone = '1';
//   }

//   const splide = new Splide(el, {
//     mediaQuery: 'max',
//     type: 'slide',
//     perPage: 1,
//     perMove: 1,
//     gap: '10px',
//     rewind: false,
//     focus: 0,
//     trimSpace: 'move',
//     pagination: false,
//     arrows: true,
//     updateOnMove: true,
//     isNavigation: true,
//     grid: { rows: 2, cols: 4, gap: { row: '10px', col: '10px' } },
//     breakpoints: { 640: { destroy: true } },
//   });

//   splide.mount(window.splide.Extensions);
// }

const splideProductThumbnailsSP_main = '#splide-product-thumbnails_sp';
const splideProductThumbnailsSP_options = {
  mediaQuery: 'min',
  type   : 'slide',
  autoplay: false,
  perPage: 6,
  perMove: 6,
  gap: "10px",
  rewind: false,
  focus  : 'center',
  trimSpace: 'move',
  pagination: false,
  arrows: true,
  updateOnMove: true,
  isNavigation: true,
  breakpoints: {
    641: {
      destroy: true,
    }
  },
}

if (document.querySelectorAll(splideProductThumbnailsSP_main).length > 0) {
  const splideProductThumbnailsSP = new Splide(splideProductThumbnailsSP_main, splideProductThumbnailsSP_options);
  splideProductThumbnailsSP.mount();
}




const splideLatestInfo_main = '#splide-latest-info';
const splideLatestInfo_options = {
  mediaQuery: 'max',
  type   : 'slide',
  autoplay: false,
  perPage: 2.8,
  rewind: false,
  focus  : 'center',
  pagination: false,
  arrows: true,
  updateOnMove: true,
  isNavigation: true,
  breakpoints: {
    640: {
      destroy: true,
    }
  },
}
if (document.querySelectorAll(splideLatestInfo_main).length > 0) {
  const splideLatestInfo = new Splide(splideLatestInfo_main, splideLatestInfo_options);
  splideLatestInfo.mount();
}


const splideServiceContent_main = '#splide-service-content';
const splideServiceContent_options = {
  mediaQuery: 'max',
  type   : 'slide',
  autoplay: false,
  perPage: 2.8,
  rewind: false,
  focus  : 'center',
  pagination: false,
  arrows: true,
  updateOnMove: true,
  isNavigation: true,
  breakpoints: {
    640: {
      destroy: true,
    }
  },
}
if (document.querySelectorAll(splideServiceContent_main).length > 0) {
  const splideServiceContent = new Splide(splideServiceContent_main, splideServiceContent_options);
  splideServiceContent.mount();
}


const splideServiceContentSP_main = '#splide-service-content_sp';
const splideServiceContentSP_options = {
  mediaQuery: 'min',
  type   : 'slide',
  autoplay: false,
  perPage: 2.8,
  rewind: false,
  focus  : 'center',
  pagination: false,
  arrows: false,
  updateOnMove: true,
  isNavigation: true,
  breakpoints: {
    641: {
      destroy: true,
    }
  },
}
if (document.querySelectorAll(splideServiceContentSP_main).length > 0) {
  const splideServiceContentSP = new Splide(splideServiceContentSP_main, splideServiceContentSP_options);
  splideServiceContentSP.mount();
}






const splideFeaturedRecomend_main = '#splide-featured-recomend';
const splideFeaturedRecomend_options = {
  mediaQuery: 'max',
  type   : 'slide',
  autoplay: false,
  perPage: 4.95,
  rewind: false,
  focus  : 'center',
  pagination: false,
  arrows: true,
  updateOnMove: true,
  isNavigation: true,
  breakpoints: {
    640: {
      destroy: true,
    }
  },
}
if (document.querySelectorAll(splideServiceContent_main).length > 0) {
  const splideFeaturedRecomend = new Splide(splideFeaturedRecomend_main, splideFeaturedRecomend_options);
  splideFeaturedRecomend.mount();
}


const splideStaffBlog_main = '#splide-staff-blog-info';
const splideStaffBlog_options = {
  mediaQuery: 'max',
  type   : 'slide',
  autoplay: false,
  perPage: 4.1,
  fixedWidth: '240px', 
  rewind: false,
  focus  : 'center',
  pagination: false,
  arrows: true,
  updateOnMove: true,
  isNavigation: true,
  breakpoints: {
    640: {
      destroy: true,
    }
  },
}
if (document.querySelectorAll(splideStaffBlog_main).length > 0) {
  const splideStaffBlog = new Splide(splideStaffBlog_main, splideStaffBlog_options);
  splideStaffBlog.mount();
}


const splideMovieContents_main = '#splide-movie-contents';
const splideMovieContents_options = {
  mediaQuery: 'max',
  type   : 'slide',
  autoplay: false,
  perPage: 4.1,
  fixedWidth: '240px', 
  rewind: false,
  focus  : 'center',
  pagination: false,
  arrows: true,
  updateOnMove: true,
  isNavigation: true,
  breakpoints: {
    640: {
      destroy: true,
    }
  },
}
if (document.querySelectorAll(splideMovieContents_main).length > 0) {
  const splideMovieContents = new Splide(splideMovieContents_main, splideMovieContents_options);
  splideMovieContents.mount();
}

// const splideCollectionPickUp_main = '#collection-splide-pickup';
// const splideCollectionPickUp_options = {
//   mediaQuery: 'max',
//   type   : 'slide',
//   autoplay: false,
//   perPage: 4.1,
//   rewind: false,
//   focus  : 'center',
//   pagination: false,
//   arrows: true,
//   updateOnMove: true,
//   isNavigation: true,
//   breakpoints: {
//     640: {
//       destroy: true,
//     }
//   },
// }
// if (document.querySelectorAll(splideCollectionPickUp_main).length > 0) {
//   const splideCollectionPickUp = new Splide(splideCollectionPickUp_main, splideCollectionPickUp_options);
//   splideCollectionPickUp.mount();
// }


